import { render, staticRenderFns } from "./CommentReply.vue?vue&type=template&id=872ff690"
import script from "./CommentReply.vue?vue&type=script&lang=js"
export * from "./CommentReply.vue?vue&type=script&lang=js"
import style0 from "./CommentReply.vue?vue&type=style&index=0&id=872ff690&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports